module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-4 full-height"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between my-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center col-sm-3 pl-0"
  }, [_c('div', {
    staticClass: "d-flex w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "glued-right bg-lighter w-100",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.account.accessType === 1) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.addRulesGroup
    }
  }, [_c('i', {
    staticClass: "ico ico-add mt-1"
  }), _vm._v(" Add Rules Group\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.getLoadingGroups) ? _c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center vh-100"
  }, [_c('span', {
    staticClass: "dark bold loading"
  }, [_vm._v("Loading")]), _vm._v(" "), _c('loader')], 1) : _c('div', [_c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.filteredResults,
      "actions": _vm.actions
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "glued-left dark pointer"
  }, [_c('i', {
    staticClass: "ico-search larger color-1 search-icon-align"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4ca371ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca371ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/revenue/rules/TabRulesGroup.vue
// module id = 3144
// module chunks = 0